import { useRef, useState } from 'react';
import { Button, Image, Overlay, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignInAlt, faSignOutAlt, faIdCard } from '@fortawesome/free-solid-svg-icons';

import { useDonationContextProvider } from 'context/DonationContextProvider';
import { DONATION_STEPS } from './data';

import { CartIcon } from 'assets/icons/cart';
import logo from 'assets/img/we-raise-images/help-yateem.png';

import { CartDrawer } from './CartDrawer';
import { GiftAidDrawer } from './GiftAidDrawer';
import { authHelpers } from '../../lib/supabase';

const HEADER_HEIGHT = 85;

function DonationHeader() {
  const { basket, setIsCartDrawerOpen, setDonationStep, setIsAuthModalOpen, setAuthModalSource, isDonorAuthenticated, setIsDonorAuthenticated, donor } =
    useDonationContextProvider();

  const [showDropdown, setShowDropdown] = useState(false);
  const accountBtnRef = useRef(null);

  const handleLogin = () => {
    setShowDropdown(false);
    setAuthModalSource('header');
    setIsAuthModalOpen(true);
  };

  const handleSignOut = async () => {
    setShowDropdown(false);
    await authHelpers.signOut();
    setIsDonorAuthenticated(false);
    setDonationStep(DONATION_STEPS.BASKET_CREATION);
  };

  return (
    <>
      {/* <div className="subheader text-center py-2">
        <a href="tel:+201021312451254" className="text-black">
          +201021312451254
        </a>
      </div> */}
      <header className=" h-94 d-flex justify-content-between align-items-center wr-donation-shadow">
        <div className="container d-flex justify-content-between align-items-center w-100">
          <div
            role="button"
            onClick={() => setDonationStep(DONATION_STEPS.BASKET_CREATION)}
            style={{ cursor: 'pointer' }}
            className="pt-4"
          >
            <Image 
              src={logo} 
              alt="Help Yateem" 
              style={{ width: '130px' }} 
            />
          </div>
          <div className="d-flex flex-column flex-md-row gap-2 gap-md-4 align-items-center">
            <Button
              ref={accountBtnRef}
              variant="outline-primary"
              className="d-flex align-items-center gap-2 py-2"
              onClick={() => setShowDropdown(prev => !prev)}
            >
              <FontAwesomeIcon icon={faUser} />
              <span className="d-none d-md-inline">Account</span>
            </Button>
            <Overlay
              target={accountBtnRef.current}
              show={showDropdown}
              placement="bottom-end"
              rootClose
              onHide={() => setShowDropdown(false)}
            >
              <Popover>
                <Popover.Body className="p-2 d-flex flex-column gap-1" style={{ minWidth: 160 }}>
                  {isDonorAuthenticated ? (
                    <>
                      <Button
                        variant="light"
                        className="d-flex align-items-center gap-2 text-start w-100"
                        onClick={() => {
                          setShowDropdown(false);
                          setDonationStep(DONATION_STEPS.PROFILE);
                        }}
                      >
                        <FontAwesomeIcon icon={faIdCard} />
                        Profile
                      </Button>
                      <Button
                        variant="light"
                        className="d-flex align-items-center gap-2 text-start w-100"
                        onClick={handleSignOut}
                      >
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        Sign Out
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant="light"
                      className="d-flex align-items-center gap-2 text-start w-100"
                      onClick={handleLogin}
                    >
                      <FontAwesomeIcon icon={faSignInAlt} />
                      Login
                    </Button>
                  )}
                </Popover.Body>
              </Popover>
            </Overlay>
            <Button
              className="d-flex justify-content-center align-items-center wr-donation-btn wr-donation-cart-btn bg-wr-donation-primary w-auto py-2"
              onClick={() => setIsCartDrawerOpen(true)}
            >
              <span className="d-flex align-items-center me-1">
                <CartIcon />
              </span>
              <span className="mx-1">{basket.length}</span>
              <span className="d-none d-md-inline">Donation</span>
            </Button>
          </div>
        </div>
      </header>
      <CartDrawer />
      <GiftAidDrawer />
    </>
  );
}

export { DonationHeader, HEADER_HEIGHT };
